// src/graphql/mutations/assignCustomerReference.js
import { gql } from '@apollo/client';

export const ASSIGN_CUSTOMER_REFERENCE = gql`
  mutation assignCustomerReference($system_id: String!, $reference: String!) {
    assignCustomerReference(system_id: $system_id, customer_reference: $reference) {
      result
    }
  }
`;

